import { render, staticRenderFns } from "./form-success.vue?vue&type=template&id=654c0d16&scoped=true&"
import script from "./form-success.vue?vue&type=script&lang=js&"
export * from "./form-success.vue?vue&type=script&lang=js&"
import style0 from "./form-success.vue?vue&type=style&index=0&id=654c0d16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c0d16",
  null
  
)

export default component.exports